'use client'
import { Box, Switch } from '@mui/material'
import { RaffleSwapDetails } from './RaffleSwapDetails'
import { useDerivedSwapInfo, useSwapActionHandlers, useSwapState } from '@/state/swap/hooks'
import { isTokenInRaffleWhitelist } from '@/utils/raffleTokens'
import { Token } from '@monadex/sdk'
import { Ticket02Icon } from '@/utils/icons'
import { Field } from '@/state/swap/actions'

export const RaffleWrapper: React.FC<any> = ({ amount, field }: { amount: string, field: Field }) => {
  const {
    currencies
  } = useDerivedSwapInfo()
  const isRaffleSupported =
    (currencies.INPUT instanceof Token && isTokenInRaffleWhitelist(currencies.INPUT.address)) ||
    (currencies.OUTPUT instanceof Token && isTokenInRaffleWhitelist(currencies.OUTPUT.address))

  const { onToggleRaffles } = useSwapActionHandlers()
  const { enterRaffle } = useSwapState()
  return (
    <>
      {isRaffleSupported &&
        <Box className='flex flex-col gap-2 opacity-80 mt-2 font-regular border py-2 border-primary/30 rounded-md p-2 justify-between items-center ease-out mb-5 w-full'>
          <Box className='flex justify-between w-full items-center gap-2'>
            <div className='flex items-center gap-2'>
              <p>Enter Raffle </p>
              <Ticket02Icon width={15} />
            </div>

            <Switch
              checked={enterRaffle}
              onClick={onToggleRaffles}
              sx={{
                '& .MuiSwitch-switchBase.Mui-checked': {
                  color: '#836EF9', // Custom thumb color when checked
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.08)'
                  }
                },
                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                  backgroundColor: '#836EF9' // Custom track color when checked
                }
              }}
            />
          </Box>
          {enterRaffle && (
            <Box className='flex w-full '>
              <RaffleSwapDetails amount={amount} field={field} currencies={currencies}/>
            </Box>
          )}
        </Box>}
    </>
  )
}
